<template>
  <div
    class="purple-button"
    :class="{ 'container-tooltip': tooltip }"
    :disabled="disabled"
  >
    <div class="content" :class="{ blocked: disabled }">
      <div class="integration">
        <i v-if="!!icon" :class="icon"></i>
        <img v-else :src="image" class="image-icon" />
        <div class="d-flex align-items-center text-neutral-700 text-left">
          {{ title }}
        </div>
      </div>
      <span class="tooltiptext">{{ tooltipContent }}</span>
      <bp-button
        :disabled="disabled"
        variant="outlined"
        icon="fa-light fa-plus"
        label="Integrar"
        block
        @click="$emit('action')"
        size="sm"
      />
    </div>
  </div>
</template>
<script>
// prop imagem deve ser -> require(path-to-image)
// assim quando chegar aqui recebo data:image

export default {
  props: {
    title: {
      type: String,
      default: "Título"
    },
    description: {
      type: String,
      default: "Description"
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    tooltipContent: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.purple-button {
  border: 1px solid #d7d7d7;
  background-color: transparent;
  border-radius: 4px;
  width: 100%;
  padding: 0;
  transition: 0.2s all;

  .integration {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 12px;
    width: 100%;
  }

  .tooltiptext {
    visibility: hidden;
    // width: 200px;
    font-size: 12px;
    color: #fff;
    font-weight: normal;
    background-color: #393444;
    border-radius: 4px;
    margin-top: 60px;
    z-index: 1;
    padding: 8px;
  }

  .content {
    &.blocked {
      opacity: 0.5;
    }
    width: 100%;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    position: relative;
    gap: 24px;

    .image-icon {
      width: 100%;
      height: auto;
      border-radius: 10px;
    }

    i {
      font-size: 38px;
      margin-left: 8px;
      margin-right: 20px;
      color: #9155ec;
    }
  }

  &.container-tooltip {
    &:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
  }
}
</style>
